(function () {
    "use strict";

    // Back to top button
    var backToTop = document.querySelector('.back-to-top');
    if (backToTop) {
      window.addEventListener('scroll', function () {
        if (window.scrollY > 100) {
          backToTop.classList.remove('hidden');
          backToTop.classList.add('flex');
        } else {
          backToTop.classList.add('hidden');
          backToTop.classList.remove('flex');
        }
      });

      backToTop.addEventListener('click', function (e) {
        e.preventDefault();
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    }

})();
